import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

// Components imports
import NavigationBar from "../../components/common/NavigationBar";
import TableComponent from "../../components/common/TableComponent";
import ArchiveNavigation from "../../components/Archive/ArchiveNavigation";
import Pagination from "../../components/common/Pagination";
import Filter from "../../components/common/Filter";
import Button from "../../components/common/Button";

// Scss imports
import css from "./Archive.module.scss";

// React icons imports
import { RiArrowDownCircleLine } from "react-icons/ri";
import { RiArrowUpCircleLine } from "react-icons/ri";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getCertainCategoryPaperNumber,
  getNotArchivedPagePapers,
} from "../../redux/actions/papersActions";

import {
  getArchiveOfCurrentUser,
  allArchiveNumber,
  getArchiveOfCurrentUserForCurrentYear,
  currentYearArchiveNumber,
} from "../../redux/actions/archiveActions";
import { getProcessors } from "../../redux/actions/processorsActions";
import { getCurrentUserData } from "../../redux/actions/currentUserActions";

interface PapersProps {}

const Papers: React.FC<PapersProps> = () => {
  const dispatch = useDispatch();

  const currentUserRole = useSelector(
    (state: any) => state.currentUser.currentUserData.role
  );

  // All categories
  const categoriesAll = useSelector(
    (state: any) => state.allCategories.categories.data
  );

  const categories = useSelector(
    (state: any) => state.allCategories.categoriesActive
  );

  // All archive
  const allPageArchive = useSelector((state: any) => state.archive.allArchive);

  // Current year archive
  const certainPageArchive = useSelector(
    (state: any) => state.archive.currentYearArchive
  );

  // All pages number
  const allArchive = useSelector(
    (state: any) => state.archive.allArchiveNumber
  );

  // Certain year pages number
  const currentYearArchive = useSelector(
    (state: any) => state.archive.currentYearArchiveNumber
  );

  const [categoryListArray, setCategoryListArray] = useState<any>([
    { value: "", name: "Изабери" },
  ]);

  const [categoriesArray, setCategoriesArray] = useState<any>([{}]);

  useEffect(() => {
    // Setting up categories array
    setCategoriesArray(categories.data);
  }, [categories]);

  //const processorsListArray: any = [{ value: "", name: "Изабери категорију" }];

  const [papersData, setPapersData] = useState([{}]);
  const [buttonText, setButtonText] = useState<string>("Прикажи све");
  const [papers, setPapers] = useState("archive");
  const [papersTitle, setPapersTitle] = useState(`Архивска књига`);
  const [pagesNumber, setPagesNumber] = useState(0);

  // Current active page
  const [activePage, setActivePage] = useState(1);

  // Page limit
  const [pageLimit, setPageLimit] = useState(10);

  // States connected to filter
  const [filterShown, setFilterShown] = useState(false);

  // Filter state
  const [sortByDateValue, setSortByDateValue] = useState("");
  const [filteredSort, setFilteredSort] = useState("");
  const [filteredCategoryType, setFilteredCategoryType] = useState("");
  const [filteredSubnumber, setFilteredSubnumber] = useState("");
  const [filteredProcessors, setFilteredProcessors] = useState("");
  const [filteredNumberOfPapers, setFilteredNumberOfPapers] = useState("");
  const [filteredRemark, setFilteredRemark] = useState("");
  const [filteredShelfLifeFrom, setFilteredShelfLifeFrom] = useState("");
  const [filteredShelfLifeTo, setFilteredShelfLifeTo] = useState("");

  // Created at to/from states
  const [createdAtFrom, setCreatedAtFrom] = useState("");
  const [createdAtTo, setCreatedAtTo] = useState("");
  const [filteredShortText, setFilteredShortText] = useState("");
  const [query, setQuery] = useState("");

  // State for selected category, depeends on this category give basic number
  const [selectedCategory, setSelectedCategory] = useState(
    categoryListArray[0].value
  );

  // State for storing value of base number
  const [baseNumber, setBaseNumber] = useState("");

  // Sort options array

  const sortByDateArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "createdAt",
      name: "Растући",
    },
    {
      value: "-createdAt",
      name: "Опадајући",
    },
  ];

  // Fake table data
  var tableData = {
    columns: [
      "Креирана дана",
      "Документа од",
      "Документа до",
      "Основни број",
      "Подброј",
      "Број докумената",
      "Рок чувања",
      "Кратак садржај",
      "Напомена",
      "Број записника о уништењу",
      "Датум записника о уништењу",
      "Ажурирање",
    ],
    rows: papersData,
  };

  useEffect(() => {
    //req dispatch(getProcessors());
    // req dispatch(getNotArchivedPagePapers(1, pageLimit));
    //dispatch(getNotArchivedPagePapers());
    // req dispatch(getCurrentUserData());
    dispatch(getArchiveOfCurrentUser(1, pageLimit, query));
    //dispatch(getArchiveOfCurrentUserForCurrentYear(1, pageLimit, query));
    // req dispatch(allArchiveNumber(""));
    //dispatch(currentYearArchiveNumber(""));
  }, []);

  useEffect(() => {
    if (sortByDateValue.length > 0) {
      setFilteredSort(`&sort=${sortByDateValue}`);
    }
  }, [sortByDateValue]);

  useEffect(() => {
    if (papers === "archive") {
      var certainPagePapersRow =
        allPageArchive &&
        allPageArchive.map((element) => {
          return {
            "Креирана дана": element.createdAt
              ? element.createdAt.split("T")[0]
              : "",
            "Документа од": element.papersFrom
              ? element.papersFrom.split("T")[0]
              : "",
            "Документа до": element.papersTo
              ? element.papersTo.split("T")[0]
              : "",
            "Основни број": element.baseNumber.baseNumber,
            Подброј: element.subnumbers.reduce(
              (prev, curr) => prev + ", " + curr
            ),
            "Број докумената": element.numberOfPapers,
            "Рок чувања": element.shelfLifeTo,
            "Кратак садржај": element.content,
            Напомена: element.remark,
            "Број записника о уништењу":
              element.recordNumber !== "N/A" ? element.recordNumber : "",
            "Датум записника о уништењу": element.recordDate
              ? element.recordDate.split("T")[0]
              : "",
            Ажурирање: element.id,
          };
        });
    }
    setPapersData(certainPagePapersRow);
  }, [certainPageArchive, allPageArchive, papers]);

  useEffect(() => {
    if (papers === "archiveLastYear") {
      setPagesNumber(Math.ceil(currentYearArchive / pageLimit));
    } else if (papers === "archive") {
      setPagesNumber(Math.ceil(allArchive / pageLimit));
    }
  }, [papers]);

  // On change basic
  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
  };

  // On category select change
  const onSelectCategoryChange = (e) => {
    setSelectedCategory(e.target.value);

    // Filter array and return object from choosen selected option
    let selectedObject: any = categoryListArray.filter((obj) => {
      return obj.value === e.target.value;
    });

    setBaseNumber(selectedObject[0].categoryNumber);
    //setSubnumber(selectedObject[0].categoryNumber + 1);
    dispatch(getCertainCategoryPaperNumber(selectedObject[0].value));
    setFilteredCategoryType(`&baseNumber=${e.target.value}`);
  };

  useEffect(() => {
    setQuery(
      filteredCategoryType +
        filteredSubnumber +
        filteredShortText +
        filteredSort +
        filteredNumberOfPapers +
        filteredRemark +
        filteredShelfLifeFrom +
        filteredShelfLifeTo
    );
  }, [
    filteredCategoryType,
    filteredSubnumber,
    filteredShortText,
    filteredSort,
    filteredNumberOfPapers,
    filteredRemark,
    filteredShelfLifeFrom,
    filteredShelfLifeTo,
  ]);

  // Filter, function for search searchDocuments
  const filterDocuments = () => {
    if (papers === "archive") {
      dispatch(getArchiveOfCurrentUser(1, pageLimit, query));
      setPagesNumber(Math.ceil(allArchiveNumber.length / pageLimit));
    }
  };

  return (
    <>
      {currentUserRole && currentUserRole !== "pending" ? (
        <div>
          <NavigationBar />
          <div className={css.container}>
            {categoriesAll && categoriesAll.length > 0 ? (
              <div className={css.contentContainer}>
                {/* Title part, title is dynamic */}
                <h1>{papersTitle}</h1>
                {/* Papers navigation */}
                <ArchiveNavigation
                  buttonText={buttonText}
                  setPapersData={setPapersData}
                  allPageArchive={allPageArchive}
                  certainPageArchive={certainPageArchive}
                  setPapers={setPapers}
                  setButtonText={setButtonText}
                  setPapersTitle={setPapersTitle}
                  setActivePage={setActivePage}
                  activePage={activePage}
                  pageLimit={pageLimit}
                />
                {/* Filter */}
                {allPageArchive && allPageArchive.length > 0 && (
                  <div
                    className={css.showFilterContainer}
                    onClick={() => setFilterShown((prevState) => !prevState)}
                  >
                    {!filterShown && <p>Прикажи филтер</p>}
                    {filterShown && <p>Сакриј филтер</p>}
                    {!filterShown && (
                      <RiArrowDownCircleLine className={css.icon} />
                    )}
                    {filterShown && (
                      <RiArrowUpCircleLine className={css.icon} />
                    )}
                  </div>
                )}
                {filterShown && (
                  <Filter
                    onSelectCategoryChange={onSelectCategoryChange}
                    categoryArray={categoryListArray}
                    setFilteredSubnumber={setFilteredSubnumber}
                    onSelectSortByDateChange={(e) => {
                      onSelectChange(e, setSortByDateValue);
                    }}
                    setCategoryListArray={setCategoryListArray}
                    categoriesArray={categoriesArray}
                    baseNumber={baseNumber}
                    setCreatedAtFrom={setCreatedAtFrom}
                    setCreatedAtTo={setCreatedAtTo}
                    createdAtFrom={createdAtFrom}
                    createdAtTo={createdAtTo}
                    setFilteredShortText={setFilteredShortText}
                    sortByDateArray={sortByDateArray}
                    setFilteredSort={setFilteredSort}
                    type="archive"
                    setFilteredNumberOfPapers={setFilteredNumberOfPapers}
                    setFilteredRemark={setFilteredRemark}
                    setFilteredShelfLifeFrom={setFilteredShelfLifeFrom}
                    setFilteredShelfLifeTo={setFilteredShelfLifeTo}
                  />
                )}
                {filterShown && (
                  <div className={css.buttonWrapper}>
                    <Button
                      text="Претражи документа"
                      onButtonClickHandler={() => filterDocuments()}
                      type="filterButton"
                    />
                  </div>
                )}
                {/* Table component */}
                {allPageArchive && allPageArchive.length > 0 && (
                  <div className={css.tableWrapper}>
                    <TableComponent data={tableData} tableType="archive" />
                  </div>
                )}
                {/* Pagination */}
                <Pagination
                  pagesNumber={pagesNumber}
                  papers={papers}
                  activePage={activePage}
                  setActivePage={setActivePage}
                  allPagePapers={certainPageArchive}
                  certainPagePapers={certainPageArchive}
                  pageLimit={pageLimit}
                  query={query}
                />
              </div>
            ) : (
              <div>
                <Link to="/categories">
                  <p className={css.enterCategories}>
                    Кликните овде да унесете категорије
                  </p>
                </Link>
              </div>
            )}
          </div>
        </div>
      ) : (
        <p className={css.pendingMessage}>
          Немате дозволу за ову акцију! Сачекајте одобрење од администратора.
          Уколико не добијете одобрење позовите на број 064/6386892
        </p>
      )}
    </>
  );
};

export default Papers;
